"use strict";

var _classCallCheck = require("C:\\Users\\M1\\OneDrive\\Desktop\\StreamGoMedia\\Wrestling Channel\\WLNNewLook\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\M1\\OneDrive\\Desktop\\StreamGoMedia\\Wrestling Channel\\WLNNewLook\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("C:\\Users\\M1\\OneDrive\\Desktop\\StreamGoMedia\\Wrestling Channel\\WLNNewLook\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Users\\M1\\OneDrive\\Desktop\\StreamGoMedia\\Wrestling Channel\\WLNNewLook\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\Users\\M1\\OneDrive\\Desktop\\StreamGoMedia\\Wrestling Channel\\WLNNewLook\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var hoist_non_react_statics_1 = __importDefault(require("hoist-non-react-statics"));

var react_1 = __importDefault(require("react"));

var language = 'pt';
var id = 1;
var subscribes = {};
var translations = {};

function subscribe(cb) {
  var newId = id;
  subscribes[newId] = cb;
  id += 1;
  return newId;
}

exports.subscribe = subscribe;

function unsubscribe(componentId) {
  delete subscribes[componentId];
}

exports.unsubscribe = unsubscribe;

function triggerSubscriptions() {
  Object.keys(subscribes).forEach(function (componentId) {
    new Promise(function (resolve, reject) {
      subscribes[componentId]();
      resolve();
    }).then();
  });
}

function setDefaultLanguage(lang) {
  language = lang;
}

exports.setDefaultLanguage = setDefaultLanguage;

function setDefaultTranslations(userTranslations) {
  if (Object.keys(translations).length !== 0) {
    setTranslations(userTranslations);
    return;
  }

  translations = userTranslations;
}

exports.setDefaultTranslations = setDefaultTranslations;

function setTranslations(userTranslations) {
  translations = userTranslations;
  triggerSubscriptions();
}

exports.setTranslations = setTranslations;

function setLanguage(lang) {
  language = lang;
  triggerSubscriptions();
}

exports.setLanguage = setLanguage;

function getLanguage() {
  return language;
}

exports.getLanguage = getLanguage;

function t(path, args) {
  var translationKeys = path.split('.');
  var translation = '';
  var translationObj = translations[language];
  translationKeys.forEach(function (key) {
    var temp = translationObj[key];

    if (typeof translationObj[key] === 'object') {
      translationObj = translationObj[key];
    }

    if (typeof temp === 'string') {
      translation = temp;
    }
  });

  if (translation) {
    if (args) {
      Object.keys(args).forEach(function (key) {
        translation = translation.replace("{".concat(key, "}"), args ? args[key] : '');
      });
    }
  } else {
    return path;
  }

  return translation;
}

exports.t = t;

function translate(Component) {
  var TranslatedComponent = /*#__PURE__*/function (_react_1$default$Comp) {
    _inherits(TranslatedComponent, _react_1$default$Comp);

    function TranslatedComponent() {
      _classCallCheck(this, TranslatedComponent);

      return _possibleConstructorReturn(this, _getPrototypeOf(TranslatedComponent).apply(this, arguments));
    }

    _createClass(TranslatedComponent, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this = this;

        this.id = subscribe(function () {
          return _this.forceUpdate();
        });
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        if (this.id) {
          unsubscribe(this.id);
        }
      }
    }, {
      key: "render",
      value: function render() {
        return react_1.default.createElement(Component, Object.assign({}, this.props, {
          t: t
        }));
      }
    }]);

    return TranslatedComponent;
  }(react_1.default.Component);

  return hoist_non_react_statics_1.default(TranslatedComponent, Component);
}

exports.translate = translate;
exports.default = {
  setDefaultLanguage: setDefaultLanguage,
  setLanguage: setLanguage,
  setDefaultTranslations: setDefaultTranslations,
  setTranslations: setTranslations,
  translate: translate,
  subscribe: subscribe,
  unsubscribe: unsubscribe,
  t: t
};